import { WindComponentAnalyzer } from '@efb/shared-core';

export type RunwayWindClassification = 'favored' | 'marginal' | 'unfavorable';

export interface RunwayEndWindAnalysis {
  runwayId: string;
  runwayHeading: number;
  headwindKts: number;
  crosswindKts: number;
  tailwindKts: number;
  classification: RunwayWindClassification;
}

const analyzer = new WindComponentAnalyzer();

export function analyzeRunwayEndWind(
  runwayId: string,
  runwayHeading: number,
  windDirection: number,
  windSpeed: number,
): RunwayEndWindAnalysis {
  const analysis = analyzer.analyzeRunway(
    { runwayId, headingDeg: runwayHeading },
    { direction: windDirection, speed: windSpeed },
  );
  const headwindKts = Math.max(0, analysis.headwindKts);
  const tailwindKts = Math.max(0, -analysis.headwindKts);

  return {
    runwayId,
    runwayHeading,
    headwindKts,
    crosswindKts: analysis.crosswindKts,
    tailwindKts,
    classification: classifyRunwayWind(analysis.crosswindKts, tailwindKts),
  };
}

export function classifyRunwayWind(
  crosswindKts: number,
  tailwindKts: number,
): RunwayWindClassification {
  if (crosswindKts > 15 || tailwindKts > 10) return 'unfavorable';
  if (crosswindKts > 10 || tailwindKts > 0) return 'marginal';
  return 'favored';
}
